export const es = {
  header: {
    tools: "herramientas",
    dev_tools_short: "dev hrrmts.",
    contact: "contactar",
  },
  content: {
    who_I_am: "quien soy",
    who_I_amContent:
      "Compañero de trabajo confiable, adaptable a cualquier tipo de proyecto, con ganas de aprender y mejorar cada día.",
    contact_me: "contactame",
    biography: "biografía",
    service: "servicio",
    services: "servicios",
    year: "año",
    years: "años",
    years_of_experience: "años de experiencia",
    projects: "proyectos",
  },
  footer: {},
  general: {
    language: "idioma",
  },
};
